import React, { useEffect } from "react";
import { FiRefreshCw } from "react-icons/fi";
import { BRAND_LOGO, BRAND_NAME } from "../../config/app/brandAssets";
import "./StayTuned.css";

/**
 * Blank hold screen while the product is updating.
 * Used for the whole origin when REACT_APP_MAINTENANCE_MODE=true,
 * and at /stay-tuned for preview.
 */
function StayTuned() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${BRAND_NAME} — Stay tuned`;
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="stay-tuned">
      <div className="stay-tuned__glow" aria-hidden="true" />

      <div className="stay-tuned__inner">
        <header className="stay-tuned__brand">
          <img
            src={BRAND_LOGO.sidebar}
            alt={BRAND_NAME}
            className="stay-tuned__logo"
          />
        </header>

        <main className="stay-tuned__content">
          <h1 className="stay-tuned__headline">
            Stay{" "}
            <span className="stay-tuned__headline-accent">tuned</span>
          </h1>

          <p className="stay-tuned__tagline">We&apos;re updating LazyStudio</p>

          <div className="stay-tuned__card">
            <p className="stay-tuned__card-lead">
              The studio is temporarily offline while we roll out improvements.
              Check back shortly.
            </p>
          </div>
        </main>

        <footer className="stay-tuned__footer">
          <span className="stay-tuned__badge">
            <FiRefreshCw
              className="stay-tuned__badge-icon"
              aria-hidden="true"
            />
            Updating
          </span>
        </footer>
      </div>
    </div>
  );
}

export default StayTuned;
